import { Box, Link, Text } from '@chakra-ui/react';

import { RegistryPackage } from '@/graphql/upbound-graphql';

const PackageMaintainer: React.FC<{ data: RegistryPackage }> = ({ data }) => {
  if (data.official && !data.maintainer) {
    return null;
  }

  return (
    <Box
      mr={{ base: '0', xl: '65px' }}
      mb={{ base: '20px', xl: '0' }}
      pb={{ base: '20px', xl: '0' }}
      borderBottom={{ base: '1px solid', xl: 'none' }}
      borderBottomColor={{ base: 'white.4', xl: 'none' }}
    >
      <Text as="span" display="block" fontSize="14px" lineHeight="20px" color="black.0" fontWeight={900} mb="8px">
        Support
      </Text>
      {data.official ? (
        <Link color="purple.0" _hover={{ textDecoration: 'underline' }} href={`mailto:${data.maintainer}`}>
          {data.maintainer?.replace(/ <.+>$/, '')}
        </Link>
      ) : (
        <Text>None</Text>
      )}
    </Box>
  );
};

export default PackageMaintainer;
